const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://assocham.org/assocham_backend/api";
const SITE_BASE = API_BASE.replace(/\/api\/?$/, "");

function formatDate(dateISO) {
  const d = new Date(dateISO);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

function mapPressRelease(pr) {
  return {
    id: pr.id,
    slug: pr.slug,
    title: pr.title,
    excerpt: pr.description,       // NewsCard isko `item.excerpt` naam se padhta hai
    dateISO: pr.dateISO,           // sort/filter ke liye
    displayDate: formatDate(pr.dateISO), // NewsCard isko `item.displayDate` naam se padhta hai
    subjects: [],
    types: ["Press Release"],
    regions: [],
  };
}

export async function fetchPressReleases({ search = "", startDate = "", endDate = "" } = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);

  const res = await fetch(`${API_BASE}/get_press_releases.php?${params.toString()}`);
  if (!res.ok) throw new Error("Failed to fetch press releases");
  const json = await res.json();
  if (!json.success) throw new Error(json.error || "Failed to fetch press releases");
  return json.data.map(mapPressRelease);
}

export async function fetchPressReleaseDetail(slug) {
  const res = await fetch(`${API_BASE}/get_press_release_detail.php?slug=${encodeURIComponent(slug)}`);
  if (!res.ok) throw new Error("Failed to fetch press release detail");
  const json = await res.json();
  if (!json.success) throw new Error(json.message || json.error || "Press release not found");
  return { ...json.data, image: `${SITE_BASE}/${json.data.image}` };
}